<div class="login">
  <div class="container"
       style="position: relative; display: flex; flex-direction: row; gap: 10px; justify-content: center;">

    <mat-card [ngStyle]="{backgroundColor: 'var(--app-bg)'}">
      <mat-card-title>
        <img [attr.src]="loginLogo ? loginLogo : '../../../assets/img/logo_light1.png'" *ngIf="masterSettings" />
      </mat-card-title>
      <mat-card-content>
        <form class="example-form" [formGroup]="formGroup" *ngIf="settings">
          <mat-form-field [floatLabel]="'always'" *ngIf="customDomain && tenantName == null && !mfaActive">
            <mat-label>Tenant Name</mat-label>
            <!--mat-select placeholder="Choose a tenant "[(value)]="selectedTenant">
            <mat-option [value]="RiskSpongeMaster">King Database</mat-option>

            <mat-option *ngFor="let tenant of tenants" [value]="tenant.databaseName">
            {{ tenant.companyName }}
            </mat-option>
        </mat-select-->

            <input matInput formControlName="tenantName" name="tenantName" (keyup)="tenantCheck($event)">

          </mat-form-field>
          <div class="example-form" *ngIf="!mfaActive && !(settings && settings.enableOidc)">
            <mat-form-field class="example-full-width" [floatLabel]="'always'">
              <mat-label>Email/Username</mat-label>
              <input matInput formControlName="username">
            </mat-form-field>
          </div>
          <div class="example-form" *ngIf="!mfaActive && !(settings && settings.enableOidc)">
            <mat-form-field class="example-full-width" [floatLabel]="'always'">
              <mat-label>Password</mat-label>
              <input matInput [type]="hidePassword ? 'password' : 'text'" formControlName="password">
              <button mat-icon-button matSuffix (click)="hidePassword = !hidePassword" type="button" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hidePassword">
                <span class="pi {{hidePassword ? 'pi-eye' : 'pi-eye-slash'}}" style="font-size: 1rem"></span>
              </button>
            </mat-form-field>
          </div>
          <div class="example-form" *ngIf="mfaActive">
            <mat-form-field class="example-full-width" [floatLabel]="'always'">
              <mat-label>Access Code</mat-label>
              <input matInput type="mfaCode" formControlName="mfaCode">
            </mat-form-field>
          </div>
          <div class="actions-form" *ngIf="mfaActive">
            <button type="button" (click)="mfaActive = false">Back to login</button>
          </div>
          <button mat-raised-button class="login-button" [ngStyle]="{backgroundColor: masterSettings?.loginButtonColor || '#0070d2'}" [disabled]="loading" (click)="onLogin()" *ngIf="!(settings && settings.enableOidc)">
            Log in <img *ngIf="loading"
                        src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
          </button>
          <button mat-raised-button class="login-button" [disabled]="loading" (click)="onAzureLogin()"
                  *ngIf="settings && settings.enableAzure && tenant && tenant.isAzureAuthenticationEnabled"
                  style="margin-top: 10px;">
            Log in with Azure
          </button>
          <button mat-raised-button class="login-button" [disabled]="loading" (click)="onOidcLogin()"
                  *ngIf="settings && settings.enableOidc"
                  style="margin-top: 10px;">
            Log in with OIDC <img *ngIf="loading"
                                  src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
          </button>
          <div class="actions-form">
            <button type="button" [routerLink]="['/forgotPassword']">Forgot Your Password?</button>
            <button type="button" (click)="customDomain = !customDomain;updateValidators()" *ngIf="isRoot">
              Use Custom
              Domain
            </button>
          </div>
        </form>
      </mat-card-content>
    </mat-card>
    <alert></alert>
    <div style="position:absolute; bottom: 23px; text-align: center; font-weight: bold; width: 100%;">
      <div class="powered-by">Version 7.3.1</div>
      <div>{{masterSettings?.footer || '&copy; 2017-2026 Rizkly, Inc. All Rights Reserved'}}</div>
    </div>
  </div>
  <div class="image" [ngStyle]="{backgroundImage: masterSettings ? loginImage ? 'url(' + loginImage + ')' : 'url(\'../../../assets/img/rizkly.jpg\')' : 'none'}">
    <!--div [innerHTML]="loginText | sanitizeHtml"></div-->
  </div>
</div>
